'use strict';

export default class LoginController {
  user = {
    name: '',
    email: '',
    password: ''
  };
  errors = {
    login: undefined
  };
  submitted = false;


  /*@ngInject*/
  constructor(FB, $state, $http, $cookies, $stateParams, baseConfigService, $rootScope, $location, $scope) {
    this.FB = FB;
    this.$state = $state;
    this.$http = $http;
    this.$cookies = $cookies;
    this.baseConfigService = baseConfigService;
    this.$rootScope = $rootScope;
    this.$location = $location;
    this.$stateParams = $stateParams;
    this.$scope = $scope;
    this.$scope.saving = false;
    this.$scope.savingSSO = false;

     // Check for token on controller initialization
     this.checkUrlToken();
  }

  isMetroEmail(email) {
    if (!email) return false;
    return email.toLowerCase().endsWith('@bayareametro.gov');
  }

  clearLoginError() {
    this.errors.login = undefined;
    this.$scope.saving = false;
    this.submitted = false;
  }

  // Optional: Add real-time check as user types
  checkEmailDomain() {
    // Show/hide SSO button based on email domain
    this.showSSOButton = this.isMetroEmail(this.user.email);
  }

  checkUrlToken() {
    var adminBaseURL = this.baseConfigService.getAdminBaseURL();
    const token = this.$location.search().token;
    // console.log(this.$stateParams);
    console.log(this.$location.search().token);

    console.log('Checking URL for token:', token); // Debug line

    if (token) {
      console.log('Token found in URL, processing...'); // Debug line

      // Store token in cookie
      this.$cookies.put('token', token);

      this.$http.get(`${adminBaseURL}/users/me/toc_app`)
      .then(user => {
        console.log("user: ", user.data);
        if(user.data){
          const userInfo = user.data;
          return this.FB.setCurrentUser(userInfo)
          .then(userData => {
            console.log('User data set:', userData);
           //Redirect to dashboard
            this.$location.path('/account/dashboard');
          });

        }
      })
      .catch(err => {
        console.log("login error: ", err)
        this.$location.path('/login');
      })
    }
  }

  login(form) {
    this.submitted = true;
    this.$scope.saving = true;
    this.errors.login = undefined;

    if(form.$valid) {

      this.FB.login({
        email: this.user.email,
        password: this.user.password
      }).then(() => {
          this.$scope.saving = false;
          // Logged in, redirect to home
          const token = this.$cookies.get('token');
          if(token) {
            this.$location.path('/account/dashboard');
          } else {
            // Token doesn't exist, handle the case accordingly
            // For example, display an error message or perform other actions
            console.log("Token not found");
          }
        })
        .catch(err => {
          const errCode = err.code;
          if (errCode === 'auth/user-not-found' || errCode === 'auth/wrong-password') {
            this.errors.login = "Invalid email and/or password"
          } else {
            console.log("Login err:", err)
            this.errors.login = this.$rootScope.login_error;
          }

          this.$scope.saving = false;

        });
    } else {
      console.log("form errors", form.$error)
      this.errors.login = form.$error.errors;
      this.$scope.saving = false;
    }
  }


  ssoLogin(form) {
    this.$scope.savingSSO = true;
    const adminBaseURL = this.baseConfigService.getAdminBaseURL();

    try {
      // Store current URL before redirect
      const currentUrl = window.location.href;
      const returnUrl = `${window.location.origin}`; // Updated return URL

      // Store the current URL as return URL
      sessionStorage.setItem('loginRedirectUrl', currentUrl);

      // Redirect to Azure login with return URL
      setTimeout(() => {
        // Add return URL to login endpoint
        // const loginUrl = `${adminBaseURL}/login?redirect_uri=${encodeURIComponent(returnUrl)}`;
        const loginUrl = `${adminBaseURL}/login?redirect_uri=${encodeURIComponent(currentUrl)}&frontend_url=${encodeURIComponent(returnUrl)}`;
        // const loginUrl = `${adminBaseURL}/login?redirect_uri=${encodeURIComponent(returnUrl)}&frontend_url=${encodeURIComponent('https://localhost:3000')}`;
        console.log('Redirecting to:', loginUrl); // Debug line
        window.location.href = loginUrl;
      }, 500);

    } catch (err) {
      this.$scope.savingSSO = false;
      console.error('SSO redirect error:', err);
      this.errors = {
        login: 'Failed to initiate SSO login. Please try again.'
      };
    }
  }

  // Add a method to check token validity
  checkToken() {
    const token = this.$cookies.get('token');
    if (!token) {
      return false;
    }

    // Check token expiry
    const expiry = this.$cookies.get('token_expiry');
    if (expiry && new Date(expiry) < new Date()) {
      // Token expired, clear cookies
      this.clearAuthCookies();
      return false;
    }

    return true;
  }
}



// WEBPACK FOOTER //
// ./client/app/account/login/login.controller.js